/*
 * dynamic layouts (cards show/hide and general animations)
 * by ole fjarestad
 */
$( document ).on('click', '*:not(html).openSecondaryPane, *:not(html).openTertiaryPane, *:not(html).openQuatenaryPane', function(e) {
	swTogglePane( $(this), 'addClass' );
	e.preventDefault();
});
$( document ).on('click', '.closeSecondaryPane, .closeTertiaryPane, .closeQuatenaryPane', function(e) {
	swTogglePane( $(this), 'removeClass' );
	e.preventDefault();
});

$( document ).on('click', '.swPane--primary', function(e) {
	swOpenPrimaryPane( $(this) );
});


/*
 * main function for dynamic layouts (cards show/hide and general animations)
 * basically just adds and removes classes to html element and panes
 * takes 2 parameters:
 *	- $this (jQuery object) the jQuery element that triggered the function call
 *	- action (string): 'addClass' = open pane, 'removeClass' = close pane
 * by ole fjarestad
 */
function swTogglePane ( $this, action )
{

	var panes = []; // array to store the panes to manipulate

	/*
	 * objects defining relationships between open/close links and corresponding panels
	 * key = classes an open/close pane-link can have (note the lack of the '.' selector)
	 * value = which pane to open/close if a link with the corresponding class is clicked (note the inclusion of the '.' selector)
	 */
	var openRelations = { 
		'openSecondaryPane'	: '.swPane--secondary',
		'openTertiaryPane'	: '.swPane--tertiary',
		'openQuatenaryPane'	: '.swPane--quatenary',
		getKey : function(n) { // return the keys of the object, used as a helper for removing classes from html element (see if action = 'removeClass' further down)
			return Object.keys(this)[n];
		}
	}
	var closeRelations = { 
		'closeSecondaryPane'	: '.swPane--secondary',
		'closeTertiaryPane'		: '.swPane--tertiary',
		'closeQuatenaryPane'	: '.swPane--quatenary',
	}


	/*
	 * add/remove classes and add elements to panes array.
	 * do different stuff depending on whether action is set to 'addClass' or 'removeClass'
	 */
	if ( action == 'addClass' ) // opening pane
	{

		$.each( openRelations, function( key, value ) { // loop through all openRelations
			if ( $this.hasClass( key ) ) { // if the element that triggered the function call has the class of the current openRelation key
				$( 'html' ).addClass( key ); // add key as a class to body. for some reason this disables the links in the sidebar menu
				var parentView = $this.closest( '.swView' ); // get parent .swView
				parentView.addClass( key ); // add key as a class to parent .swView
				panes.push( parentView.find( value ) ); // and add the pane with a class corresponding to the current openRelation value to the panes array
			}
		});

	}
	else if ( action == 'removeClass' ) // closing pane
	{

		var classCounter = 0; // keep track of number of close-classes $this has

		$.each( closeRelations, function( key, value ) { // loop through all closeRelations
			if ( $this.hasClass( key ) ) { // if the element that triggered the function call has the class of the current closeRelation key

				// $( 'html' ).removeClass( openRelations.getKey(classCounter) ); // remove key class from body
				var parentView = $this.closest( '.swView' ); // get parent .swView
				var subsequentPanes = $this.closest( '.swPane' ).find( '~ .swPane' ); // get the .swPane elements that follow the pane where the "close event" occured (still within the same .swView)
				subsequentPanes.removeClass( 'swOpen' ); // remove swOpen class from the subsequent panes (and thus close them)

				for (var i = classCounter; i <= 10; i++) { // 10 = max number of .swPane's in a .swView. Increase to enable more panes
					$( 'html' ).removeClass( openRelations.getKey(i) ); // remove key class from body. see the addClass for reason why it's commented out
					parentView.removeClass( openRelations.getKey(i) ); // remove key class from parent .swView
				}

				panes.push( parentView.find( value ) ); // and add the pane with a class corresponding to the current openRelation value to the panes array
			}
			classCounter++;
		});

	}


	for (var i = 0; i <= panes.length - 1; i++)
	{
		if ( action == 'addClass' )
		{
			panes[i].addClass( 'swOpen' );
		}
		else if ( action == 'removeClass' )
		{
			panes[i].removeClass( 'swOpen' );
		}
	}


	/*if ( $this.hasClass( 'openSecondaryPane' ) ) {
		var secondaryPane = $this.closest( '.swView' ).find( '.swPane--secondary' );
	}
	if ( $this.hasClass( 'openTertiaryPane' ) ) {
		var tertiaryPane = $this.closest( '.swView' ).find( '.swPane--tertiary' );
	}
	if ( $this.hasClass( 'openQuatenaryPane' ) ) {
		var quatenaryPane = $this.closest( '.swView' ).find( '.swPane--quatenary' );
	}*/


	/*var secondaryPane = $this.closest( '.swView' ).find( '.swPane--secondary' );
	//console.log( secondaryPane );
	if ( action == 'addClass' ) {
		$( 'html' ).addClass( 'SecondaryPane' );
		secondaryPane.addClass( 'swOpen' );
	} else if ( action == 'removeClass' ) {
		$( 'html' ).removeClass( 'SecondaryPane' );
		secondaryPane.removeClass( 'swOpen' );
	}*/
}

function swOpenPrimaryPane ($this)
{

	var parentView = $this.closest( '.swView' ); // get parent .swView

	if ( parentView.hasClass( 'openTertiaryPane' ) )
	{
		parentView.removeClass( 'openSecondaryPane' );
		parentView.removeClass( 'openTertiaryPane' );
		var subsequentPanes = $this.closest( '.swPane' ).find( '~ .swPane.swOpen' ); // get the .swPane elements that follow the pane where the "close event" occured (still within the same .swView)
		// console.log( subsequentPanes );
		subsequentPanes.removeClass( 'swOpen' );
		// console.log( subsequentPanes );
	}

}



//////////////////
// WEBPACK FOOTER
// ./src/assets/js/partials/layout.js
// module id = ./src/assets/js/partials/layout.js
// module chunks = main